import type { IconComponent } from './Ic';

export function Empty({
  icon: Icon,
  title,
  detail,
}: {
  icon: IconComponent;
  title: string;
  detail?: string;
}) {
  return (
    <div className="empty">
      <Icon className="ic" />
      <div className="t">{title}</div>
      {detail && <div className="d">{detail}</div>}
    </div>
  );
}
